import { render, staticRenderFns } from "./SendFileDialog.vue?vue&type=template&id=6fe22542&scoped=true"
import script from "./SendFileDialog.vue?vue&type=script&lang=js"
export * from "./SendFileDialog.vue?vue&type=script&lang=js"
import style0 from "./SendFileDialog.vue?vue&type=style&index=0&id=6fe22542&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe22542",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/zak/Documents/arawa/codes/cloud_bbb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fe22542')) {
      api.createRecord('6fe22542', component.options)
    } else {
      api.reload('6fe22542', component.options)
    }
    module.hot.accept("./SendFileDialog.vue?vue&type=template&id=6fe22542&scoped=true", function () {
      api.rerender('6fe22542', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ts/views/SendFileDialog.vue"
export default component.exports